export default "__VITE_ASSET__Dj3hKIci__"